export function createWhereToWatch(whereToWatch) {
  if (!whereToWatch || !Array.isArray(whereToWatch) || whereToWatch.length === 0) {
    return null;
  }

  const section = document.createElement('div');
  section.className = 'where-to-watch-section';
  section.style.marginTop = 'var(--space-xl)';

  section.innerHTML = `
    <div class="section-header">
      <h2 class="section-title">Where to Watch</h2>
    </div>
    <div style="display: flex; gap: var(--space-sm); flex-wrap: wrap;">
      ${whereToWatch.map(item => `
        <a href="${item.url}" target="_blank" rel="noopener noreferrer" class="badge-pill clickable-item" style="padding: 8px 16px; font-size: 0.85rem; border-color: var(--border-gold); background: var(--bg-surface-elevated);">
          <span style="width: 8px; height: 8px; border-radius: 50%; background: var(--accent-emerald); display: inline-block;"></span>
          <strong>${item.platform}</strong>
          <span style="color: var(--accent-gold); font-size: 0.75rem;">• ${item.badge || item.type}</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-left: 4px;">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
        </a>
      `).join('')}
    </div>
  `;

  return section;
}
